import {RequestV2StatusType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {OptionData} from 'ui-library/menus/MenuConstants';
import {capitalize, constantCaseToWords} from 'util/NameUtil';

export function getRequestV2SubmissionStatusOptionDatas(): Promise<Array<OptionData>> {
  return Promise.resolve(
    Object.values(RequestV2StatusType).map((requestV2Status) => ({
      value: requestV2Status,
      name: capitalize(constantCaseToWords(requestV2Status)),
    }))
  );
}
